(function () {
  if (window.__mcSwatchTidy) return;
  window.__mcSwatchTidy = true;
  if (!/\/products\//.test(location.pathname)) return;

  function build(opt) {
    if (opt.__mcVacc) return;
    var title = opt.querySelector(':scope > .t4s-swatch__title');
    if (!title) return;
    opt.__mcVacc = true;
    opt.classList.add('mc-vacc');

    var sign = document.createElement('span');
    sign.className = 'mc-vacc__sign';
    sign.setAttribute('aria-hidden', 'true');
    title.appendChild(sign);
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');

    var body = document.createElement('div');
    body.className = 'mc-vacc__body';
    var inner = document.createElement('div');
    inner.className = 'mc-vacc__body-inner';
    body.appendChild(inner);
    var node = title.nextSibling;
    while (node) {
      var next = node.nextSibling;
      inner.appendChild(node);
      node = next;
    }
    opt.appendChild(body);
    body.style.maxHeight = 'none';

    function expand() {
      opt.classList.remove('is-collapsed');
      body.style.maxHeight = body.scrollHeight + 'px';
      window.setTimeout(function () {
        if (!opt.classList.contains('is-collapsed')) body.style.maxHeight = 'none';
      }, 300);
    }
    function collapse() {
      body.style.maxHeight = body.scrollHeight + 'px';
      void body.offsetHeight;
      opt.classList.add('is-collapsed');
      body.style.maxHeight = '0px';
    }

    var locked = false;
    function toggle() {
      if (locked) return;
      locked = true;
      window.setTimeout(function () {
        locked = false;
      }, 350);
      opt.classList.contains('is-collapsed') ? expand() : collapse();
    }

    title.addEventListener('click', toggle);
    title.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  }

  function run() {
    var opts = document.querySelectorAll('.t4s-product__info-wrapper .t4s-swatch__option');
    if (!opts.length) return false;
    opts.forEach(build);

    var vacc = document.querySelectorAll('.t4s-product__info-wrapper .mc-vacc');
    vacc.forEach(function (v) {
      v.classList.remove('mc-vacc--last');
    });
    if (vacc.length) vacc[vacc.length - 1].classList.add('mc-vacc--last');
    return true;
  }

  function init() {
    if (run()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (run() || ++tries > 20) clearInterval(t);
    }, 200);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
